import React from 'react';
import { observer } from 'mobx-react';

interface ITextLabel {
    text: string;
}

const TextLabel = observer(({ text }: ITextLabel) => {
    const isHTML = text && text.match(/(<([^>]+)>)|(&([a-z]+);)/gi);
    const hasUnicode = text && text.match(/(&#.+;)/gi);

    return isHTML || hasUnicode ? <div dangerouslySetInnerHTML={{ __html: text }} /> : <>{text}</>;
});

export default TextLabel;
